import { Component, Inject } from '@angular/core';
import { LogDexieService, LogInstanceToken, LogInterface } from '@evorait/pace-logging';
import { TranslateService } from '@ngx-translate/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { IClipboardResponse } from 'ngx-clipboard';

@Component({
    selector: 'pace-core-error-log',
    templateUrl: './error-log.component.html',
    styleUrls: ['./error-log.component.scss'],
    standalone: false,
})
export class ErrorLogComponent {
    public logEntriesString: string;
    public isCopied = false;
    public clipboardCopyButtonLabel: string;
    public constructor(
        @Inject(LogInstanceToken) private readonly log: LogInterface,
        private readonly translate: TranslateService,
        private readonly dexieLogger: LogDexieService,
        public readonly modalInstance: BsModalRef,
    ) {
        this.logEntriesString = '';
        this.clipboardCopyButtonLabel = <string>this.translate.instant('ERROR_LOG_BUTTON_COPY_TO_CLIPBOARD');
        this.dexieLogger
            .getAllLogEntries()
            .then((logEntries) => {
                const formattedEntriesArray = logEntries.map((logEntry) => {
                    return `${logEntry.toString()}`;
                });
                this.logEntriesString = formattedEntriesArray.join('\n');
            })
            .catch((error) => {
                this.logEntriesString = '';
                this.log.error(
                    `PaceCoreErrorLogComponent: constructor: Error on loading log entries from database: ${error}`,
                );
            });
    }

    /**
     * This function is triggered On Successful copy of log from the ngx-clipboard attribute
     *
     * @param event The event object from the clipboard
     */
    public onClipboardCopySuccess(event: IClipboardResponse): void {
        if (event.isSuccess) {
            this.isCopied = true;
            this.clipboardCopyButtonLabel = <string>this.translate.instant('ERROR_LOG_BUTTON_COPIED_LABEL');
        }
    }
}
